/**
 * Utility function to build URL query string from params object
 * @param {Object} params - Object with key-value pairs for URL parameters
 * @returns {string} - URL query string (e.g., "?key1=value1&key2=value2") or empty string
 */
export function buildUrlParams(params = {}) {
  const urlParams = new URLSearchParams();
  
  // Build URL params from params dict
  Object.keys(params).forEach(key => {
    if (params[key] != null && params[key] !== '') {
      urlParams.append(key, params[key]);
    }
  });
  
  const paramString = urlParams.toString();
  return paramString ? `?${paramString}` : '';
}

/**
 * Get a URL parameter value by name
 * @param {string} name - Parameter name to get
 * @param {string|Location} url - URL string or Location object (defaults to window.location)
 * @returns {string|null} - Parameter value or null if not found
 */
export function getParameterByName(name, url = window.location) {
  const urlString = typeof url === 'string' ? url : url.href;
  const urlObj = new URL(urlString);
  return urlObj.searchParams.get(name);
}
